import React, {useState, useEffect} from 'react';
import { Button } from '../../bootstrap/index.jsx';

const ActionButtons = ({onCancel, onSave}) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // Component did mount, reset
    if (loading){
      setLoading(false);
      setSaving(false);
    }
  }, []);

  return <div className="pull-right  mr-1">
      <Button 
        type="default" 
        className="mr-1" 
        onClick={(e) => { setLoading(true); e.preventDefault(); onCancel(e) }}
        disabled={loading}
      >
        {I18n.t('cancel')}
      </Button>
      <Button 
        onClick={(e) => { setSaving(true); setLoading(true); e.preventDefault(); onSave(e) }}
        disabled={loading}
      >
          {saving ? I18n.t('saving') : I18n.t('save')}
      </Button>
    </div>
}

export default ActionButtons;